import React from "react";
import Head from "next/head";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import Loading from "../src/components/Loading";
import StructuredData from "../src/components/StructureData";
import { seoFunct } from "../src/config/next-seo.config";
import { NextSeo } from "next-seo";
import HomeComponent from "../src/pages/HomePage/HomePage";

const Home: React.FC = () => {
  const router = useRouter();

  return (
    <>
      <NextSeo {...seoFunct("homeSeo")} />

      <StructuredData
        data={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "KonfHub",
          url: "https://konfhub.com/",
          logo: "https://konfhub.com/img/logo.svg",
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "",
            contactType: "customer service",
          },
          sameAs: [
            "https://www.facebook.com/konfhub/",
            "https://www.twitter.com/konfhub",
            "https://www.youtube.com/c/KonfHubTech",
            "https://www.linkedin.com/in/konfhub/",
            "https://instagram.com/konfhub_tech_conference",
          ],
        }}
      />

      <HomeComponent />
    </>
  );
};

export default Home;
